import './header';
import './footer';
import './newsletter';

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
  methods: {
    // cartPreview() {
    //   function updateCartPreview(items) {
    //     let cartPreview = document.querySelector('.cart-preview');
    //     if (cartPreview) {
    //       let itensCartPreview = document.querySelector('.items_cart_preview');
    //       itensCartPreview.innerHTML = '';
    //       let allQtd = 0;
    //       items.forEach((item) => {
    //         let brandHtml = item.brand ? `<p class="cart-item-content-brand">${item.brand}</p>` : '';
    //         let formattedPrice = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.unit_price);
    //         let variations = item.variation_value ? `<p class="cart-item-content-size">Tamanho: <b>${item.variation_value}</b></p>` : '';

    //         let itemHTML = `
    //         <li class="cart-item">
    //           <figure>
    //             <img src="${item.image_medium}" alt="${item.name}">
    //           </figure>
    //           <div class="cart-item-content">
    //             ${brandHtml}
    //             <h4 class="cart-item-content-name">${item.name}</h4>
    //             <p class="cart-item-content-price">${formattedPrice}</p>
    //             <p class="cart-item-content-qtd">Quantidade: <b>${item.quantity}</b></p>
    //             ${variations}
    //           </div>
    //         </li>
    //         `;

    //         const liElement = document.querySelector(`li[itemSku="${item.sku}"]`);

    //         if (liElement) {
    //           liElement.classList.add('already-bought');
    //         }

    //         itensCartPreview.innerHTML += itemHTML;
    //         allQtd = Number(allQtd) + Number(item.quantity);
    //       });

    //       const alQtdd = document.querySelector('.cart-preview__sub-total-qtd-qtd');
    //       if (alQtdd) {
    //         alQtdd.innerHTML = allQtd;
    //       }

    //       localStorage.setItem('cartItems', JSON.stringify(items));

    //       // Adiciona o event listener para os botões de deletar
    //       document.querySelectorAll('.delete-item-button').forEach(button => {
    //         button.addEventListener('click', function () {
    //           let itemId = this.getAttribute('data-original-id');
    //           deleteCartItem(itemId);
    //         });
    //       });
    //     }
    //   }

    //   $.ajax({
    //     type: 'GET',
    //     url: '/api/front/cart/items/?version=2',
    //     headers: { 'Content-Type': 'application/json' },
    //     dataType: 'json'
    //   }).done(function (data) {
    //     if (data && data.cart_data && data.cart_data.items) {
    //       updateCartPreview(data.cart_data.items);
    //       let getActualQtd  = 0;
    //       for (var i = 0; i <= data.cart_data.items.length - 1; i++) {
    //         getActualQtd = Number(getActualQtd) + Number(data.cart_data.items[i].quantity);
    //       }
    //       const qtdHeader = document.querySelectorAll('.quant_itens_carrinho');
    //       if (qtdHeader) {
    //         qtdHeader.forEach((item) => {
    //           item.innerHTML = getActualQtd;
    //         });
    //       }
    //       const alQtdd = document.querySelector('.cart-preview__sub-total-qtd-qtd');
    //       if (alQtdd) {
    //         alQtdd.innerHTML = getActualQtd;
    //       }
    //       const cartTotalValue = document.querySelector('.total_value_cart_preview');
    //       if (cartTotalValue) {
    //         cartTotalValue.innerHTML = data.cart_data.total;
    //       }
    //     }
    //   });

    //   $(document).on("ajaxComplete", function (event, xhr, settings) {
    //     if (settings.url.includes('/api/front/cart/items/') && settings.type === 'POST') {
    //       let valid_status = [200, 201];
    //       if (valid_status.includes(xhr.status)) {
    //         const responseJson = xhr.responseJSON.cart_data.items;
    //         let getActualQtd  = 0;
    //         for (var i = 0; i <= responseJson.length - 1; i++) {
    //           getActualQtd = Number(getActualQtd) + Number(responseJson[i].quantity);
    //         }
    //         const qtdHeader = document.querySelectorAll('.quant_itens_carrinho');
    //         if (qtdHeader) {
    //           qtdHeader.forEach((item) => {
    //             item.innerHTML = getActualQtd;
    //           });
    //         }
    //         const alQtdd = document.querySelector('.cart-preview__sub-total-qtd-qtd');
    //         if (alQtdd) {
    //           alQtdd.innerHTML = getActualQtd;
    //         }
    //         const cartTotalValue = document.querySelector('.total_value_cart_preview');
    //         if (cartTotalValue) {
    //           cartTotalValue.innerHTML = xhr.responseJSON.cart_data.total;
    //         }
    //         updateCartPreview(responseJson);
    //       }
    //     }
    //   });
    // },
  },
  mounted() {
    // this.cartPreview();
  }
});

/* Fix bug with slick on new product render (vitrine) */
const elementosLazy = document.querySelectorAll('.lazy-img');

elementosLazy.forEach(elemento => {
  const dataSrc = elemento.getAttribute('data-src');
  if (dataSrc) {
    elemento.setAttribute('src', dataSrc);
    elemento.removeAttribute('data-src');
  }
});

// Cart has a delay and this code here fix it
setTimeout(() => {
  if (document.body.id === 'cart') {
    const elementosLazy = document.querySelectorAll('.lazy-img');

    elementosLazy.forEach(elemento => {
      const dataSrc = elemento.getAttribute('data-src');
      if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
      }
    });
  }
}, 5000);

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

/* Name hover translate effect */
const figcaptionElements = document.querySelectorAll('.product-item__content--figcaption-name');

figcaptionElements.forEach((figcaption) => {
  const anchor = figcaption.querySelector('a');
  if (anchor) {
    const figcaptionWidth = figcaption.offsetWidth;
    const anchorWidth = anchor.offsetWidth;

    const transitionDuration = Math.max(1, Math.abs(anchorWidth - figcaptionWidth) / 100);

    if (anchorWidth > figcaptionWidth) {
      anchor.style.transition = `all ${transitionDuration}s linear`;
      figcaption.classList.add('action');
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  /* If Black Friday Template enabled */
  var elements = document.querySelectorAll('.product-campaigns-tags__campaign');

  Array.from(elements).forEach(function (tag) {
    if (tag.textContent.includes("Black") || tag.textContent.includes("BLACK") || tag.textContent.includes("black")) {
      tag.classList.add("black");
    }
  });

  /* duvidas-frequentes tab_accordion */
  var tabAccordions = document.querySelectorAll('.tab_accordion');
  var contentAccordions = document.querySelectorAll('.content_accordion');

  tabAccordions.forEach(function (tabAccordion, index) {
    tabAccordion.addEventListener('click', function () {
      tabAccordions.forEach(function (tab) {
        tab.classList.remove('active');
      });

      contentAccordions.forEach(function (content) {
        content.classList.remove('active');
      });

      tabAccordion.classList.add('active');
      contentAccordions[index].classList.add('active');
    });
  });

  (function ($) {
    $.fn.visible = function (partial) {

      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

  })(jQuery);

  function loadWidgets(event) {

    $(".product-item:not(.widget-loaded)").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("widget-loaded");
        $(el).children().trigger("mouseenter");
      } else {
        //el.removeClass("visible");
      }
    });
  }

  $(window).scroll(loadWidgets);
  setTimeout(loadWidgets, 0);

  const comunicado = document.querySelector('.comunicado');
  if (comunicado) {
    $('#carrousel-comunicado').slick({
      arrows: true,
      dots: false,
      infinite: true,
      autoplay: false,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 2000,
    });
  }

  const aboutThemes = document.querySelector('.about-themes');
  if (aboutThemes) {
    $('#carrousel-second-section').slick({
      arrows: false,
      dots: false,
      infinite: false,
      autoplay: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 2000,
      responsive: [
        {
          breakpoint: 991,
          settings: "unslick"
        },
      ]
    });
  }

});

const pageExtraCarrosel = document.querySelector('#dynamic-page-extra .image-list');
if (pageExtraCarrosel) {
  $('#dynamic-page-extra .image-list').slick({
    arrows: false,
    dots: false,
    infinite: false,
    autoplay: true,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 2000,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
    ]
  });
}